import React from 'react';
import { useI18n } from '../context/I18nContext';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ className = '' }) {
  const { lang, setLang } = useI18n();

  const toggle = () => setLang(lang === 'en' ? 'no' : 'en');

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-slate-400 hover:text-white hover:bg-navy-700 transition-colors ${className}`}
      title={lang === 'en' ? 'Bytt til norsk' : 'Switch to English'}
    >
      <Globe size={14} />
      <span>{lang === 'en' ? 'NO' : 'EN'}</span>
    </button>
  );
}
